import React, { useState } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import {
  getUserDynamicRsvpQuestions,
  saveQuestionSelection,
} from "../redux/rsvpSlice";
import { useEffect } from "react";
import Navbar from "./Navbar";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { gridColumnLookupSelector } from "@mui/x-data-grid";

const QuestionSelection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [questions, setQuestions] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [guestQuestion, setGuestQuestion] = useState({question_value:["",""]});
  
  const loadQuestions = async() => {
    const res = await dispatch(getUserDynamicRsvpQuestions());
    setQuestions(res.payload?.user_questions.map((q)=>{
      if (q.question_number===5) {
        if (!Array.isArray(q.question_value) || q.question_value.length===0) {
          q.question_value=["",""];
        }
        if (q.question_value.length===1) {
          q.question_value.push("");
        }
        if (q.question_value.length>2) {
          q.question_value=[q.question_value[0], q.question_value[1]];
        }
      }
      return {...q, hide_groups:Array.isArray(q.hide_groups) ? q.hide_groups.filter((g)=>g!==null) : []}
    }));
    setGuestQuestion(res.payload?.user_questions.find(q=>q.question_number==5));
    setGroups(res.payload?.groups);
  }

  useEffect(() => {
    loadQuestions();
  }, []);

  async function changeSelection(question) {
    setQuestions((old)=> old.map((q)=>(q.id!==question.id) ? q : question ));
    const res = await dispatch(saveQuestionSelection({questions:[question]}));
    if (!res?.payload?.message) {
      toast.error("Save failed");
      loadQuestions();
    }
    console.log(res);
  }

  function handleClickShownQuestion(question) {
    console.log("handleClickShownQuestion question", question);
    if (question.question_number===1) return; // full name
    if (question.question_number===3) return; // email
    if (question.question_number===6) return; // what events
    
    var newGroups = [];
    if (selectedGroup===null) { // all
      newGroups = groups.map((g)=>g.id);
    } else {
      newGroups = [...question.hide_groups, selectedGroup];
    }
    changeSelection({...question, hide_groups: newGroups});
  }

  const addGuestQuestion = () => {
    setGuestQuestion(q=>{
      let val = [...q.question_value];
      if (!Array.isArray(val)) {
        val=[];
      }
      val.push("");
      return {...q, question_value:val};
    });
  }
  const deleteGuestQuestion = (idx) => {
    setGuestQuestion(q=>{
      let val = [...q.question_value];
      if (Array.isArray(val) && idx>=0 && idx<val.length) {
        val.splice(idx, 1);
      }
      return {...q, question_value:val};
    });
  }
  const saveGuestQuestion = async ()=> {
    const id = JSON.parse(localStorage.getItem("user"));
    const resp = await axios.post(
      process.env.REACT_APP_API_URL+`/questions/saveGuestOf/${id}`, guestQuestion
    );
    if (!Array.isArray(resp.data) || resp.data[0]?.id!==guestQuestion.id) {
      toast.error('Failed to save "guest of" name list');
    }
  }

  const handleGuestQChange = (newValue, idx) => {
    setGuestQuestion(q=>{
      let val = [...q.question_value];
      if (Array.isArray(val) && (idx >= 0) && (idx < val.length)) {
        val[idx] = newValue;
      }
      return {...q, question_value:val};
    });
  }

  const guestQuestionUsed = () => {
    const guestQ = questions.find(q=>q.question_number==5);
    return (!guestQ) ? false : shownFilter(guestQ);
  }

  function handleClickHiddenQuestion(question) {
    console.log("handleClickHiddenQuestion question", question)
    var newGroups = [];
    if (selectedGroup!==null) { // not all
      newGroups = question.hide_groups.filter((g)=>g!==selectedGroup && g!==null);
    }
    changeSelection({...question, hide_groups: newGroups});
  }

  const handleNext = (event) => {
    if (guestQuestionUsed() && (guestQuestion.question_value.length<2) || (guestQuestion.question_value[0]=="" || guestQuestion.question_value[1]=="")) {
      toast.error(`Add names for your "guest of" question`)
      return;
    }

    event.preventDefault();
    navigate("/guest/food/questions");
  };

  const handleGroupClick = (group_id) => {
    setSelectedGroup(group_id);
    console.log("GROUP", group_id, groups, questions)
  }

  const shownFilter = (q)=> {
    if (selectedGroup===null) { // all
      return q.hide_groups?.length<groups?.length;
    }
    return q.hide_groups.indexOf(selectedGroup)<0;
  }

  const hiddenFilter = (q)=> {
    if (selectedGroup===null) { // all
      return q.hide_groups?.length>=groups?.length;
    }
    return q.hide_groups.indexOf(selectedGroup)>=0;
  }

  const selectedGroupName = (shown) => {
    if (selectedGroup===null) {
      return (shown) ? "one or more groups" : "all groups";
    }
    const group = groups?.find((g)=> g.id===selectedGroup)
    return "group " + group?.groupname;
  }

  return (
    <div>
      <Navbar />

      <div className="container card-b-1">
        <div className="row">
          <h6 className="col-md-12 welcome-text">
            <h4 className="heading">CHOOSE YOUR RSVP QUESTIONS</h4>
            Enter your name and your partner’s name below so your guests can confirm whose guest they are. If you do not wish to collect this information, simply fill in your names and hide the guest of question.
            <br></br> <br></br>
            To customise RSVP questions, click on a group to add or view the questions you want that group to answer. You can tailor questions specifically for head guests or their associated guests, depending on the group they’re in. To remove a question, simply click the arrow next to it to move it to the <span style={{fontWeight:"bold"}}>Hidden</span> section.
            <br></br> <br></br>
            <span style={{fontWeight:"bold"}}>Important</span>: The question “Which events can you attend?”— Is essential for collecting RSVP responses and cannot be removed.

            <br></br> <br></br>
            <div className="refer">
              <a href="/video-guides" target="_blank">Online video guides</a><br/><br/>
            </div>
          </h6>
        </div>

        <div className="groom-block card-home">
          <div className="row groom-rsvp">
            <div className="col-md-12">
              <Link className="flot-left-btn mb-0" to={"/invitations"}>
                Back
              </Link>
              <button className="flot-tight-btn mb-0" onClick={handleNext}>
                Next{" "}
              </button>
            </div>
          </div>
        </div>

        {guestQuestionUsed() && <div className="groom-block card-home col-md-12">
          {guestQuestion && <>
            <h5>Please enter your name and your partners name for the "Guest of" question</h5>
            <div className="mb-1">
              <TextField 
                id="guestOfName0"
                variant = "outlined"
                size = "small" 
                className = "bg-light guestOfName me-4"
                value = {guestQuestion.question_value[0]} 
                onChange={(e)=>handleGuestQChange(e.target.value, 0)} 
                onBlur={saveGuestQuestion} 
              />
              <TextField 
                id="guestOfName1"
                variant = "outlined"
                size = "small" 
                className = "bg-light guestOfName"
                value = {guestQuestion.question_value[1]} 
                onChange={(e)=>handleGuestQChange(e.target.value, 1)} 
                onBlur={saveGuestQuestion} 
              />
            </div>
          </>}
        </div>}

        <div className="card-home mb-1">
          <div className="tabs-home row">
            <div className="col-md-3">
              <div className={(null===selectedGroup) ? "questionTab questionTabSelected" : "questionTab"} 
                  onClick={() => handleGroupClick(null)} >
                <span>All groups</span>
              </div>
            </div>

            {groups?.map((item) => (
              <div className="col-md-3">
                <div className={(item.id===selectedGroup) ? "questionTab questionTabSelected" : "questionTab"} 
                    onClick={() => handleGroupClick(item.id)} >
                  <span>{item.groupname}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="d-md-flex col-md-12">
          <div className="card-home col-sm-6" style={{borderRight:"2px solid #fff"}}>
            <div className="row">
              <h5><span style={{fontWeight:"bold"}}>Shown</span> to {selectedGroupName(true)}</h5>
              {questions?.filter(shownFilter).map((question) => (
                <button className="question-btn my-1" id={`question_${question.id}`}
                onClick={()=>handleClickShownQuestion(question)}
                >
                  <span style={{float:"right",marginLeft:"5px"}}>🡒</span>
                  {question.questions}
                </button>
              ))}
            </div>
          </div>
          <div className="card-home col-sm-6" style={{borderLeft:"2px solid #fff"}}>
            <div className="row">
              <h5><span style={{fontWeight:"bold"}}>Hidden</span> from {selectedGroupName()}</h5>
              {questions?.filter(hiddenFilter).map((question) => (
                <button className="question-btn my-1" id={`question_${question.id}`}
                onClick={()=>handleClickHiddenQuestion(question)}
                >
                  <span style={{marginRight:"5px"}}>🡐</span>
                  {question.questions}
                </button>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
  
}

export default QuestionSelection;
